import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";

function MenuIcon2({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 464.205 464.205" fill={finalColor}>
      <G>
        <G id="grip-solid-horizontal_1_">
          <Path d="m435.192 406.18h-406.179c-16.024 0-29.013-12.99-29.013-29.013s12.989-29.013 29.013-29.013h406.18c16.023 0 29.013 12.99 29.013 29.013-.001 16.023-12.99 29.013-29.014 29.013z" />
          <Path d="m435.192 261.115h-406.179c-16.024 0-29.013-12.989-29.013-29.012s12.989-29.013 29.013-29.013h406.18c16.023 0 29.013 12.989 29.013 29.013s-12.99 29.012-29.014 29.012z" />
          <Path d="m435.192 116.051h-406.179c-16.024 0-29.013-12.989-29.013-29.013s12.989-29.013 29.013-29.013h406.18c16.023 0 29.013 12.989 29.013 29.013s-12.99 29.013-29.014 29.013z" />
        </G>
      </G>
    </Svg>
  );
}
export default MenuIcon2;
